{
	"yearSelectorLabel": "Select year",
	"fetchError": "Could not load the available years. Please try again."
}
